import { useCallback, useState } from 'react'

const MAX_FILL_MS = 3_600_000

/**
 * `useFillTime()` (Frontend §4.6): whole milliseconds from the form's first render (P-03 or P-09) to now, clamped to
 * API.md §1.12's 0–3,600,000. A new form (after "Try again", or a new hold's P-09) mounts again and starts again. The
 * server measures its own fill time (`fill_fast`); this value is evidence only, never trusted alone.
 */
export function useFillTime(): () => number {
  const [startedAt] = useState(() => performance.now())
  return useCallback(() => Math.min(MAX_FILL_MS, Math.max(0, Math.round(performance.now() - startedAt))), [startedAt])
}
